import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';

import CartIcon from 'mdi-material-ui/CartOutline';

const CartFullIcon = styled(props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <defs />
    <path d="M17 18c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2M1 2h3.3l.9 2H8v2H6.1l2.4 5H16l2.8-5H16V4h4c.6 0 1 .4 1 1 0 .2 0 .3-.1.5L17.3 12c-.3.6-1 1-1.7 1H8.1l-.9 1.6v.1c0 .1.1.2.2.2H19v2H7c-1.1 0-2-.9-2-2 0-.4.1-.7.2-1l1.4-2.4L3 4H1V2m6 16c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2" />
    <path d="M12 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2" />
  </svg>
))`
  width: 24px;
  height: 24px;
  fill: currentColor;
`;

const NavCart = ({ cart }) => (
  <Button to="/cart" component={Link} size="small">
    {cart.cartItemCount > 0 ? <CartFullIcon /> : <CartIcon />}
  </Button>
);

export default connect(
  state => ({
    cart: state.cart
  }),
  {}
)(NavCart);
